import commonSetting from '@intelligence/components/DownloadCommon/DownloadPage/configs/commonSetting';

const getFilename = (params: Record<string, any>) => {
  const [startDate = '', endDate = ''] = params?.dateRange || [];
  return `Store Ranks_Mobile Global_Region_Detail_${startDate}_${endDate}`;
};
const columns = [
  {
    title: 'Date',
    key: 'date',
  },
  {
    title: 'Rank',
    key: 'rank',
  },
  {
    title: 'Game',
    key: 'name',
  },
  {
    title: 'Release Date',
    key: 'release_time',
    formatter: 'release_date',
  },
  {
    title: 'Main Genre',
    key: 'mainGenre',
  },
  {
    title: 'Sub Genre',
    key: 'genre_source',
  },
];

const getDownloadApiParams = (params: any) => {
  const {
    dateRange = [],
    start_release_time: startReleaseTime,
    end_release_time: endReleaseTime,
    ...restParams
  } = params || {};
  const [startDate, endDate] = dateRange;
  const dataMethod = params?.data_method;
  const selectTopType = params?.select_top_type;

  delete restParams.data_method;
  delete restParams.data_amount;

  const apiParams: Record<string, any> = {
    ...restParams,
    filter: {
      start_release_date: startReleaseTime,
      end_release_date: endReleaseTime,
    },
    group: 'download',
    start_date: startDate,
    end_date: endDate,
    top: params?.select_top || 0,
  };

  if (dataMethod === 'selectTop' && selectTopType) {
    apiParams.select_top_type = selectTopType;
  } else {
    delete apiParams.select_top_type;
  }

  return apiParams;
};

export default (params: Record<string, any>) => {
  return {
    ...commonSetting,
    isUsingNewMethod: false,
    dataKey: ['list'],
    $$fileName: getFilename(params),
    downloadFetchApi: '/api/v1/intelligence_pc/getNewStoreRankDetailedListPlus',
    downloadApiParams: getDownloadApiParams(params),
    sheetName: ['Store Rank Details'],
    'Store Rank Details': columns,
  };
};
